export default "/pools-header-image.28e47283c29bf3e275fbb81dd47ad4d2.png";